import React from 'react';
import { useInView } from 'react-intersection-observer';


const FadeUpSection = ({ children }) => {
    const { ref, inView } = useInView({
        triggerOnce: true, 
        threshold: 0.1,    
    });

    return (
        <div ref={ref}
            className= {`fade-up-section ${inView ? 'fade-up-visible' : ''} `}>
            {children}
        </div>
    );
};

export default FadeUpSection;
